/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Export = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 15 15">
      <path d="M7.5,-0.0002 C7.776,-0.0002 8,0.2238 8,0.4998 C8,0.7768 7.776,0.9998 7.5,0.9998 L7.5,0.9998 L1,0.9998 L1,13.9998 L14,13.9998 L14,7.9668 C14,7.6908 14.224,7.4668 14.5,7.4668 C14.776,7.4668 15,7.6908 15,7.9668 L15,7.9668 L15,14.4998 C15,14.7768 14.776,14.9998 14.5,14.9998 L14.5,14.9998 L0.5,14.9998 C0.224,14.9998 0,14.7768 0,14.4998 L0,14.4998 L0,0.4998 C0,0.2238 0.224,-0.0002 0.5,-0.0002 L0.5,-0.0002 Z M14.4999,-0.0004 C14.5659,-0.0004 14.6299,0.0136 14.6909,0.0376 C14.8139,0.0886 14.9109,0.1866 14.9619,0.3086 C14.9859,0.3706 14.9999,0.4346 14.9999,0.4996 L14.9999,0.4996 L14.9999,4.4996 C14.9999,4.7766 14.7759,4.9996 14.4999,4.9996 C14.2239,4.9996 13.9999,4.7766 13.9999,4.4996 L13.9999,4.4996 L13.9999,1.7066 L5.3539,10.3536 C5.2559,10.4516 5.1279,10.4996 4.9999,10.4996 C4.8719,10.4996 4.7439,10.4516 4.6469,10.3536 C4.4509,10.1586 4.4509,9.8416 4.6469,9.6466 L4.6469,9.6466 L13.2929,0.9996 L10.4999,0.9996 C10.2239,0.9996 9.9999,0.7766 9.9999,0.4996 C9.9999,0.2236 10.2239,-0.0004 10.4999,-0.0004 L10.4999,-0.0004 Z" />
    </BaseSvgIcon>
  )
}

export default Export
